import { useReprintModal } from './hooks/useReprintModal'
import { useCancelOrderDialog } from '@/components/OrdersModule/OrderDetail/CancelOrderDialog/hooks/useCancelOrderDialog'
import { State } from '@/features/orders/constants/app'
import MenuButton from '@/features/ui/buttons/components/MenuButton'
import MenuItem from '@/features/ui/buttons/components/MenuButton/parts/MenuItem'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface ContextMenuProps {
    orderUuid: string
}

const ContextMenu: FC<ContextMenuProps> = ({ orderUuid }) => {
    const { t } = useTranslation()
    const order = useAppSelector(ordersSelectors.orderByUuid(orderUuid))

    const showCancelOrderDialog = useCancelOrderDialog(orderUuid)
    const showReprintModal = useReprintModal(orderUuid)

    const [open, setOpen] = useState(false)

    const handleToggleOpen = () => {
        setOpen((prev) => !prev)
    }

    const handleReprintPress = () => {
        setOpen(false)
        showReprintModal()
    }

    const handleCancelPress = () => {
        setOpen(false)
        showCancelOrderDialog()
    }

    if (!order) return null

    const canCancel = order.state !== State.Cancelled

    return (
        <MenuButton onToggleOpen={handleToggleOpen} open={open}>
            <MenuItem
                label={t('order.detail.action.reprint')}
                onPress={handleReprintPress}
                divider={canCancel}
            />
            {canCancel && (
                <MenuItem
                    label={t('order.detail.cancel')}
                    onPress={handleCancelPress}
                    divider={false}
                />
            )}
        </MenuButton>
    )
}

export default ContextMenu
